document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collapsible-content details').forEach(function (details) {
    const content = details.querySelector('.details-content');
    if (!content) return;

    details.addEventListener('toggle', function () {
      if (details.open) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = '0px';
      }
    });
  });
});